module.exports = __webpack_public_path__ + "img/DE05876.6afd2c93.svg";